import { Box, Flex, Text } from "@mantine/core";
import Link from "next/link";
import { memo } from "react";
import { MdChevronLeft } from "react-icons/md";

const BackPageLink = ({ href, text }: { href: string; text: string }) => {
  return (
    <Box sx={{ width: "fit-content", padding: "4px 0" }}>
      <Link href={href}>
        <Flex align="center" gap={4}>
          <MdChevronLeft size={24} />
          <Text>{text}</Text>
        </Flex>
      </Link>
    </Box>
  );
};

export const BackPageLinkMemo = memo(BackPageLink);
